import { render, staticRenderFns } from "./PinsSection.vue?vue&type=template&id=268341f0&scoped=true&"
import script from "./PinsSection.vue?vue&type=script&lang=js&"
export * from "./PinsSection.vue?vue&type=script&lang=js&"
import style0 from "./PinsSection.vue?vue&type=style&index=0&id=268341f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268341f0",
  null
  
)

component.options.__file = "PinsSection.vue"
export default component.exports